import { render, staticRenderFns } from "./DialogEmailDelete.vue?vue&type=template&id=6020a5ec&"
import script from "./DialogEmailDelete.vue?vue&type=script&lang=js&"
export * from "./DialogEmailDelete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports